import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { TechStackService } from 'src/portal/buyerscaddy-api/services/tech-stack.service';
import { loadTechStack, loadTechStackFailure, loadTechStackSuccess } from './tech-stack.actions';

@Injectable()
export class TechStackEffects {
  loadTechStack$;
  constructor(private actions$: Actions, private techStackService: TechStackService) {
    this.loadTechStack$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadTechStack),
        concatMap((action) =>
          this.techStackService.getTechStack({id:action.id}).pipe(
            map((techStack) => loadTechStackSuccess({ techStack })),
            catchError((error) => of(loadTechStackFailure({ error })))
          )
        )
      )
    );
  }




}
